import React, { useMemo, useState } from 'react';

import { Button, Dropdown } from '@duxton-web/ui';
import {
  AiFilled,
  // Adding this to satisfy the linter, but it's not used as Manual campaign is hidden
  // eslint-disable-next-line no-unused-vars
  MegaphoneFilled,
  FolderFilled,
  AddUniversal,
} from '@duxton-web/icons';
import {
  colorBrandSecondaryDefault,
  // Adding this to satisfy the linter, but it's not used as Manual campaign is hidden
  // eslint-disable-next-line no-unused-vars
  colorStatusInformativeDefault,
  colorContentSubtle,
} from '@duxton-web/design-tokens/themes/light';
import { useDispatch, useSelector } from 'react-redux';

import AddNewProjectModal from 'omega-rtc/components/form/ucd/AddNewProjectModal';
import AddCampaignForm from 'omega-rtc/components/form/ucd/AddCampaignForm';
import {
  UCD_RESOURCE_NAMES,
  UCD_ACTION_TYPES,
  UCD_ROUTES_LINK,
  PROJECT,
  SMART_CAMPAIGN,
  MANUAL_CAMPAIGN,
  JOURNEY_CAMPAIGN_GROUP,
  ADD_NEW_CAMPAIGN,
  ADD_NEW_PROJECT,
} from 'omega-rtc/constants/ucd';
import { createUCDCampaign } from 'omega-rtc/actions/ucd';
import ShowIfAuthorized from 'omega-rtc/components/form/ucd/common/ShowIfAuthorized';
import { useJourneyCampaignGroupEnabled } from 'omega-rtc/utils/portal-config';

interface Props {
  router: any;
  project?: any;
  showProject?: boolean;
  showCampaign?: boolean;
}

const CreateCampaignProjectButton = ({
  router,
  showProject = true,
  showCampaign = true,
  project,
}: Props) => {
  const journeyCampaignGroupEnabled = useJourneyCampaignGroupEnabled();
  const menuItems = useMemo(() => {
    return [
      {
        key: SMART_CAMPAIGN,
        icon: (
          <AiFilled
            style={{
              fontSize: '20px',
              color: colorBrandSecondaryDefault,
            }}
          />
        ),
        label: (
          <ShowIfAuthorized
            conditions={[
              {
                resource: UCD_RESOURCE_NAMES.campaign,
                action: UCD_ACTION_TYPES.create,
              },
            ]}
          >
            Smart campaign
          </ShowIfAuthorized>
        ),
        show: showCampaign,
      },
      {
        key: JOURNEY_CAMPAIGN_GROUP,
        icon: (
          <MegaphoneFilled
            style={{
              fontSize: '20px',
              color: colorStatusInformativeDefault,
            }}
          />
        ),
        label: (
          <ShowIfAuthorized
            conditions={[
              {
                resource: UCD_RESOURCE_NAMES.campaign,
                action: UCD_ACTION_TYPES.create,
              },
            ]}
          >
            Journey Campaign Group
          </ShowIfAuthorized>
        ),
        show: showCampaign && journeyCampaignGroupEnabled,
      },
      {
        key: PROJECT,
        icon: (
          <FolderFilled
            style={{ fontSize: '20px', color: colorContentSubtle }}
          />
        ),
        label: (
          <ShowIfAuthorized
            conditions={[
              {
                resource: UCD_RESOURCE_NAMES.project,
                action: UCD_ACTION_TYPES.create,
              },
            ]}
          >
            Projects
          </ShowIfAuthorized>
        ),
        show: showProject,
      },
    ].filter((item) => item.show);
  }, [showProject, showCampaign, journeyCampaignGroupEnabled]);
  const user = useSelector((state: any) => state.app.user);
  const countries = useSelector((state: any) => state.countries.entities);
  const configs = useSelector((state: any) => state.ucd.configs);

  const [showModalKey, setShowModalKey] = useState('');
  const handleMenuItemClick = (item: any) => {
    switch (item.key) {
      case PROJECT:
        setShowModalKey(ADD_NEW_PROJECT);
        break;
      case MANUAL_CAMPAIGN:
        setShowModalKey(ADD_NEW_CAMPAIGN);
        break;
      case SMART_CAMPAIGN:
        router.push(UCD_ROUTES_LINK.SMART_CAMPAIGN_CREATE());
        break;
      case JOURNEY_CAMPAIGN_GROUP:
        router.push(UCD_ROUTES_LINK.JOURNEY_CAMPAIGN_GROUP_CREATE());
        break;

      default:
        break;
    }
  };

  const dispatch = useDispatch();

  const onCreateManualCampaign = (data: any, projectID: any) => {
    dispatch(createUCDCampaign(data, projectID));
  };

  return (
    <ShowIfAuthorized
      conditions={[
        {
          resource: UCD_RESOURCE_NAMES.campaign,
          action: UCD_ACTION_TYPES.create,
        },
        {
          resource: UCD_RESOURCE_NAMES.project,
          action: UCD_ACTION_TYPES.create,
        },
      ]}
    >
      <Dropdown
        menu={{
          items: menuItems.map((item) => {
            delete item.show;
            return item;
          }),
          onClick: handleMenuItemClick,
        }}
        trigger={['click']}
      >
        <Button size="middle" type="primary" icon={<AddUniversal />}>
          Create
        </Button>
      </Dropdown>
      <AddNewProjectModal
        open={showModalKey === ADD_NEW_PROJECT}
        onSubmit={() => {
          setShowModalKey('');
        }}
        onCancel={() => setShowModalKey('')}
        router={router}
      />
      {showModalKey === ADD_NEW_CAMPAIGN && (
        <AddCampaignForm
          user={user}
          countries={countries}
          configs={configs}
          project={project}
          createCampaign={onCreateManualCampaign}
          router={router}
          closeModal={() => setShowModalKey('')}
        />
      )}
    </ShowIfAuthorized>
  );
};

export default CreateCampaignProjectButton;
